<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="100px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select v-model="mainSearch.whCode" placeholder="请选择" clearable="clearable" filterable>
              <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="生产工单" class="EL-Form-Item">
            <el-input v-model="mainSearch.opCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
          <el-form-item label="产品编号" class="EL-Form-Item">
            <el-input v-model="mainSearch.prodCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input v-model="mainSearch.matCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="saveSearch">查询</el-button>
            <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="生产叫料编号" class="EL-Form-Item">
            <el-input v-model="mainSearch.pmCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="状态" class="EL-Form-Item">
            <el-select v-model="mainSearch.status" clearable="clearable">
              <el-option key="0" value="PICK,PICKING" label="默认(待拣货,拣货中)"></el-option>
              <el-option key="1" value="PICKING" label="拣货中"></el-option>
              <el-option key="3" value="PICKCOMPLETE" label="拣货完成"></el-option>
              <el-option key="4" value="CHECKOUT" label="配送出库"></el-option>
              <el-option key="5" value="COMPLETE" label="完成"></el-option>
              <el-option key="6" value="CLOSE" label="关闭"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>
    </box>
    <box fill>
      <plabel text="仓库叫料">
        <el-button v-authority="'BACK_MENU3_M23_B1'" class="btn-t-edit" @click="insertdialogShow()">新增叫料</el-button>
        <el-button v-authority="'BACK_MENU3_M23_B2'" class="btn-t-edit" @click="isReceivingDetails = true">工单同步</el-button>
        <!-- <el-button v-authority="'BACK_MENU3_M23_B3'" class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button> -->
        <el-button v-authority="'BACK_MENU3_M23_B3'" class="btn-t-edit" @click="getPrintList()">单据打印</el-button>
        <el-button v-authority="'BACK_MENU3_M23_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAllMain">
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column label="工厂编号" align="center" prop="fcCode"> </el-table-column>
        <el-table-column label="通道编号" align="center" prop="whCode"> </el-table-column>
        <el-table-column label="成品编号" align="center" prop="produceCode"> </el-table-column>
        <el-table-column label="物料编号" align="center" prop="matCode"> </el-table-column>
        <el-table-column label="物料描述" align="center" prop="matName"> </el-table-column>
        <el-table-column label="物料需求数量" align="center" prop="matRealQuan"> </el-table-column>
        <el-table-column label="已发数量" align="center" prop="matPickQuan"> </el-table-column>
        <el-table-column label="规值" align="center" prop="matSpecs"> </el-table-column>
        <el-table-column label="生产工单" align="center" prop="opCode"> </el-table-column>
        <el-table-column label="生产叫料编号" align="center" prop="pmCode"> </el-table-column>
        <el-table-column label="需求时间" align="center" prop="requireTime"> </el-table-column>
        <el-table-column label="状态" align="center" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 'CREATE'">下发</span>
            <span v-if="scope.row.status == 'PICK'">待拣货</span>
            <span v-if="scope.row.status == 'PICKING'">拣货中</span>
            <span v-if="scope.row.status == 'PICKCOMPLETE'">拣货完成</span>
            <span v-if="scope.row.status == 'CHECKOUT'">配送出库</span>
            <span v-if="scope.row.status == 'COMPLETE'">完成</span>
            <span v-if="scope.row.status == 'CLOSE'">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="是否紧急" align="center" prop="topFlag">
          <template slot-scope="scope">
            <span>{{ scope.row.topFlag ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="紧急原因" align="center" prop="topMessage"> </el-table-column>
        <!-- <el-table-column label="排序" align="center" prop="matSort"> </el-table-column> -->
        <el-table-column label="操作人" align="center" prop="person"> </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime"> </el-table-column>
        <el-table-column label="更新时间" align="center" prop="updateTime"> </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-authority="'BACK_MENU3_M23_B5'" class="btn-t-edit" type="primary" @click="closeMatByPick(scope.row)" :disabled="scope.row.status == 'CREATE' || scope.row.status == 'PICK' ? false : true">关闭</el-button>
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 新增叫料 -->
    <el-dialog title="新增叫料" :visible.sync="dialogShow" class="fromDialog" :style="$popups.popups(0.8, 0.9)" :close-on-click-modal="false" :show-close="false">
      <div style="overflow: hidden; padding-bottom: 10px">
        <el-form label-position="right" label-width="80px">
          <el-col :lg="5" :xl="5">
            <el-form-item label="通道" class="EL-Form-Item">
              <el-select v-model="insertData.whCode" filterable @change="changeWhCode();">
                <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="需求时间" class="EL-Form-Item">
              <el-date-picker v-model="insertData.requireTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" @change="topFunction"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="是否紧急" class="EL-Form-Item">
              <el-select v-model="insertData.topFlag" placeholder="请选择" clearable="clearable" @change="topMessages(insertData.topFlag)">
                <el-option label="是" :value="true" />
                <el-option label="否" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.topFlag">
            <el-form-item label="紧急原因" class="EL-Form-Item">
              <el-select v-model="insertData.topMessage" filterable>
                <el-option v-for="item in insertDataList.resultList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :xl="4" style="float: right">
            <el-button class="btn-t-edit" @click="getBomList()">查询</el-button>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="叫料方式" class="EL-Form-Item">
              <el-select v-model="insertData.pmType" @change="(insertDataList.bomList = []), changePmType()">
                <el-option value="ORDER" label="工单叫料"></el-option>
                <el-option value="BOM" label="BOM叫料"></el-option>
                <el-option value="MATERIAL" label="物料叫料"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'ORDER'">
            <el-form-item label="工单" class="EL-Form-Item">
              <el-select v-model="insertData.opCode" filterable @change="changeOrder($event)">
                <el-option v-for="item in insertDataList.orderList" :key="item.opId" :value="item.opCode" :label="item.opCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType != 'MATERIAL'">
            <el-form-item label="成品编号" v-if="insertData.pmType == 'BOM'" class="EL-Form-Item">
              <el-select v-model="insertData.prodCode" filterable clearable>
                <el-option v-for="item in insertDataList.bomList" :key="item.bpId" :value="item.prodCode" :label="item.prodCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成品编号" v-if="insertData.pmType == 'ORDER'" class="EL-Form-Item">
              <el-input v-model="insertData.prodCode" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'MATERIAL'">
            <el-form-item label="物料编号" class="EL-Form-Item">
              <el-select v-model="insertData.matCode" filterable clearable remote :remote-method="remoteMethod" :loading="loading" @change="remoteMethod">
                <el-option v-for="item in materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'ORDER'">
            <el-form-item label="工单数量" class="EL-Form-Item">
              <el-input v-model="insertData.jihuaquan" placeholder="请输入" :disabled="true" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType != 'MATERIAL'">
            <el-form-item label="叫料数量" class="EL-Form-Item">
              <el-input v-model="insertData.jiaoliaoQuan" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="5" :xl="5">
            <el-form-item label="需求订单" class="EL-Form-Item">
              <el-input v-model="insertData.requireOrder" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>-->
        </el-form>
      </div>
      <div>
        <h-table :style="$popups.harvestRecordStyle(0.55)" :headerCellStyle="mainData.headerCellStyle" :data="insertDataList.matList" :row-class-name="tableRowClassName">
          <el-table-column label="通道编号" prop="whCode" align="center"> </el-table-column>
          <el-table-column label="工单编号" prop="opCode" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
          <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
          <el-table-column label="工单数量" prop="produceQuan" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="物料需求总量" prop="matCountQuan" align="center"> </el-table-column>
          <el-table-column label="已申请总量" prop="matCallQuan" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="BOM用量" prop="bomQuan" align="center"> </el-table-column>
          <el-table-column label="剩余需求数量" prop="matQuan" align="center"> </el-table-column>
          <el-table-column label="实际需求数量" prop="matRealQuan" align="center" width="100px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.matRealQuan" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="当前库存" prop="whQuan" align="center">
            <template slot-scope="scope">
              <el-button size="small" @click="getWhDetails(scope.row)">{{ scope.row.whQuan }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="待检库存" prop="waitQuan" align="center"></el-table-column>
          <el-table-column label="规值" prop="matSpecs" align="center"> </el-table-column>
          <el-table-column label="最小包装量" prop="minBoxNum" align="center"> </el-table-column>
          <!-- <el-table-column label="需求时间" prop="requireTime" align="center"> </el-table-column> -->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="delList(scope.row.index)" class="btn-t-delete">删 除</el-button>
            </template>
          </el-table-column>
        </h-table>
      </div>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="insertdialogClose" type="info" class="btn-t-info">关 闭</el-button>
        <el-button :loading="insertStockProductMats" class="btn-t-edit" @click="insertStockProductMat()" :disabled="insertDataList.matList.length > 0 ? false : true">确认叫料</el-button>
      </div>
    </el-dialog>

    <!-- 库存数量详情 -->
    <el-dialog title="库存数量详情" :visible.sync="whDetailShow" class="fromDialog" :style="$popups.popups(0.8, 0.8)" :close-on-click-modal="false" :show-close="false">
      <div>
        <h-table :style="$popups.harvestRecordStyle(0.63)" :headerCellStyle="mainData.headerCellStyle" :data="whDetailList" :row-class-name="tableRowClassName">
          <!-- <el-table-column :width="50" label="编号" prop="wiId" align="center"> </el-table-column> -->
          <el-table-column label="工厂编号" prop="fcCode" align="center"> </el-table-column>
          <el-table-column label="通道编号" prop="whCode" align="center"> </el-table-column>
          <el-table-column label="库位编号" prop="lcCode" align="center"> </el-table-column>
          <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
          <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
          <el-table-column :width="100" label="总数量" prop="matQuan" align="center"> </el-table-column>
          <el-table-column :width="100" label="已分配数" prop="matDistrQuan" align="center"> </el-table-column>
          <el-table-column :width="100" label="可用数量" prop="matAvaliableQuan" align="center"> </el-table-column>
          <el-table-column label="箱号" prop="boxBarcode" align="center"> </el-table-column>
          <el-table-column label="批次号" prop="batchNo" align="center"> </el-table-column>
          <el-table-column label="库存状态" prop="wiStatus" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
              <span v-if="scope.row.wiStatus == 'FREEZE'">拣货中</span>
              <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
              <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
              <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" prop="orderCode" align="center"> </el-table-column>
          <el-table-column label="入库时间" prop="matCreateTime" align="center"> </el-table-column>
          <el-table-column label="是否退料" prop="returnFlag" align="center"> 
            <template slot-scope="scope">
              <span v-if="(scope.row.returnFlag == true)">退料</span>
              <span v-if="(scope.row.returnFlag == false)">正常</span>
            </template>
          </el-table-column>
        </h-table>
      </div>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="whDetailShow = false" type="info" class="btn-t-info">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <!-- <el-dialog title="" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
      <div style="margin-top:20px;margin-left:900px">
        <el-button class="btn-t-info" type="info" @click="printShow = false;printList = [];">取消</el-button>
        <el-button class="btn-t-edit" @click="(print = true), (printShow = false)">打印</el-button>
      </div>
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;color: black;">
              物料需求表
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <div>申请人：{{ person }}</div>
              <div>日期：{{ timeDate }}</div>
            </div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th colspan="7"><span style="color:black;">通道下单</span> <br /><span style="font-size: 14.5px;color:black;">下单时间：1）9:00 &nbsp;&nbsp; 2）12：00 &nbsp;&nbsp; 3）17:00 &nbsp;&nbsp; 4）20:00 &nbsp;&nbsp; 5）22:00</span> <br /><span style="font-size: 15px;color:red;">(请在以下时间点前下单，22:00为应急要料时间)</span></th>
                </tr>
                <tr class="td">
                  <td><span>序号</span></td>
                  <td>产品号</td>
                  <td>通道号</td>
                  <td>物料号</td>
                  <td>数量</td>
                  <td>实发数量</td>
                  <td>备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index" class="tr">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.produceCode }}</td>
                  <td>{{ item.whCode }}</td>
                  <td>{{ item.matCode }}</td>
                  <td>{{ item.matRealQuan }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </v-print>
      <div style="margin-top: 50px;height:70px">
      </div>
    </el-dialog> -->

    <el-dialog title="打印" :visible.sync="printShow" width="1500px" :close-on-click-modal="false">
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div style="margin-left: -1200px; margin-top: 50px">
              {{ timeDate }}
            </div>
            <div style="margin-right: -1200px; margin-top: 50px">
              <el-button size="small" type="primary" @click="clearPrintData">
                清空数据
              </el-button>
            </div>
            <div style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;">
              {{ operaType }}拣货单
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <!-- <span>工序：</span> -->
              <!-- <span>通道：{{ whCodes }}</span>
              <span>班次：</span> -->
              <span>申请人：{{ persons }}</span>
              <span>日期：{{ timeDate }}</span>
              <span>需求库房（通道）：</span>
              <span>拣货库房：</span>
            </div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th></th>
                  <th colspan="3">需求下单</th>
                  <th colspan="4">拣货接单</th>
                  <!-- <th colspan="2">通道接料</th> -->
                </tr>
                <tr class="td">
                  <td>序号</td>
                  <td>型号</td>
                  <td>规值</td>
                  <td>数量</td>
                  <td>实发库位</td>
                  <td>箱号</td>
                  <!-- <td>数量</td> -->
                  <td>实发数量</td>
                  <td>备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.matCode }}-{{ item.matName }}</td>
                  <td>{{ item.matSpecs }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td>{{ item.laCodeReal }}</td>
                  <td>{{ item.boxBarcode }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td></td>
                  <!-- <td>{{ item.matQuan }}</td> -->
                </tr>
              </table>
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <span>总数量：{{ summarySumNumber }}</span>
              <span>箱数：{{ boxNumber }}</span>
            </div>
          </div>
        </div>
      </v-print>

      <div style="margin-top: 50px;height:80px">
        <el-button class="btn-t-edit" @click="printShow = false">取消</el-button>
        <el-button class="btn-t-edit" @click="(print = true), (printShow = false)">打印</el-button>
      </div>
    </el-dialog>

    <!-- 工单同步 -->
    <el-dialog title="工单同步" :visible.sync="isReceivingDetails" class="fromDialog" :style="$popups.popups(0.2, 0.25)" :close-on-click-modal="false" :show-close="false" @click.stop>
      <el-form label-position="right" label-width="80px">
        <el-form-item label="工单编号" prop="tableOrderCode" class="EL-Form-Item">
          <el-input v-model="tableOrderCode" placeholder="请输入"> </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="isReceivingDetails = false" class="btn-t-info">取 消</el-button>
        <el-button @click="synchronization()" class="btn-t-edit">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style>
.el-table .success-row {
  color: #ff0000;
}
</style>
<script>
import vPrint from "syl-vue-printer";
import moment from "moment";
export default {
  name: "ProductionCall",
  components: {
    vPrint,
  },
  data() {
    return {
      printObj: {
        id: "demo",
        popTitle: "",
      },
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      // 筛选条件
      mainSearch: {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        whCode: localStorage.getItem("whCode") || "", //通道编号
        pmCode: "", //	生产叫料编号
        opCode: "", //	生产工单编号
        prodCode: "", //	物料编号
        matCode: "", //	物料编号
        status: "PICK,PICKING", //	状态
        date: [],
      },
      //多选
      checkListMain: [],
      //打印类型
      operaType: "",
      //弹出框
      dialogShow: false,
      insertData: {
        fcCode: localStorage.getItem("fcCode") || "",
        whCode: localStorage.getItem("whCode") || "",
        requireTime: "", //需求时间
        topFlag: false, //是否紧急
        topMessage: "",
        pmType: "MATERIAL", //叫料方式
        opCode: "",
        prodCode: "", //成品编号
        matCode: "",
        jiaoliaoQuan: "",
        jihuaquan: "",
        matSpecsFlag: true, //是否区分分差
        requireOrder: "", //需求订单
      },
      insertDataList: {
        orderList: [],
        resultList: [], //原因
        warehouseAreaList: [],
        bomList: [],
        matList: [],
      },
      loading: false, //加载中

      factoryList: [],
      factoryData: {},
      warehouseList: [],
      warehouseData: {},

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注

      person: localStorage.getItem("user"),
      personNumber: localStorage.getItem("empNumber"),

      downloadLoading: false, //下载中
      insertStockProductMats: false,

      //打印
      print: false,
      printShow: false,
      printList: [],
      timeDate: "",

      matSortList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // 物料列表
      materialList: [],
      // 输入框延时加载
      isSetTimeout: null,

      //库存数量详情
      whDetailList: [],
      whDetailShow: false,

      //工单窗口
      isReceivingDetails: false,
      //工单编号
      tableOrderCode: "",

      //单据打印的数据
      spIdList: [],
      timeDate: new Date(),
      whCodes: "",
      persons: localStorage.getItem("userName"),
      //总数量
      sumNumber: 0,
      //汇总总数量
      summarySumNumber: 0,
      //总箱数
      boxNumber: 0,
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.mainData.nowPage = 1;
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },

  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        },
      };
    },
  },

  activated() {
    // 从页面跳转传值
    let pmCode = this.$route.query.pmCode;
    if (pmCode) {
      this.mainSearch.date = [];
      this.mainSearch.pmCode = pmCode;
    } else {
      //添加默认时间
      this.mainSearch.date = [];
      this.mainSearch.date.push(moment().subtract("d", 0).format("YYYY-MM-DD"));
      this.mainSearch.date.push(moment().add("d", 1).format("YYYY-MM-DD"));
    }
    this.getMaterial();
    this.getWarehouse();
    this.getFactoryAll();
    /* 获取首页的数据 */
  },
  methods: {
    //同步工单
    synchronization() {
      if (this.tableOrderCode == "" || this.tableOrderCode.length != 7) {
        this.$message({
          message: "请填写正确的工单编号!",
          type: "warning",
        });
        return;
      }
      this.$http
        .request({
          url: "/api/order/opCodeSynchronization",
          method: "POST",
          showLoading: true,
          params: {
            opCode: this.tableOrderCode,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.isReceivingDetails = false;
            this.tableOrderCode = "";
            this.$message({
              message: "同步成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.mainData.nowPage = 1;
        this.getTableData();
      }, 1000);
    },

    tableRowClassName({ row }) {
      if (this.insertData.pmType == "ORDER" && row.matRealQuan - 0 + row.matCallQuan > row.matCountQuan) {
        return "success-row";
      }
    },

    //清空打印数据
    clearPrintData() {
      this.printList = [];
      this.spIdList = [];
      this.summarySumNumber = 0;
      this.sumNumber = 0;
      this.boxNumber = 0;
      this.whCodes = "";
    },

    getTableData() {
      this.$http
        .request({
          url: "/api/stockProduceMat/getStockProductList",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage, //	页号
            pageSize: this.mainData.pageSize, //	页大小
            fcCode: this.mainSearch.fcCode || null, //	工厂编号
            whCode: this.mainSearch.whCode || null,
            pmCode: this.mainSearch.pmCode || null, //	生产叫料编号
            opCode: this.mainSearch.opCode || null, //	生产工单编号
            prodCode: this.mainSearch.prodCode || null, //	物料编号
            matCode: this.mainSearch.matCode || null, //	物料编号
            status: this.mainSearch.status || null, //	状态
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, //	开始时间
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, //	结束时间
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },

    /**
     * 查询最近的工单
     */
    getOrderProductList() {
      this.$http
        .request({
          url: "/api/orderProduct/getOrderProductList",
          method: "GET",
          params: {
            whCode: this.insertData.whCode || null,
            // fcCode: this.insertData.fcCode || null, //	当前登录的工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.insertDataList.orderList = res.data;
            if (this.insertData.pmType == "ORDER") {
              this.insertData.opCode = "";
              this.insertData.jihuaquan = "";
              this.insertData.jiaoliaoQuan = "";
            }
          } else {
            this.$message.error("错误");
          }
        });
    },

    changeOrder(opCode) {
      let orderInfo = this.insertDataList.orderList.find((i) => i.opCode == opCode);
      this.insertData.fcCode = orderInfo.fcCode;
      this.insertData.whCode = orderInfo.whCode;
      this.insertData.prodCode = orderInfo.matCode;
      this.insertData.jiaoliaoQuan = orderInfo.matQuan;
      this.insertData.jihuaquan = orderInfo.matQuan;
    },
    /**
     * 当前所有BOM信息
     */
    getProdList() {
      this.$http
        .request({
          url: "/api/bom/getProdList",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "", // 当前登录的工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.insertDataList.bomList = res.data;
          } else {
            this.$message.error("错误");
          }
        });
    },

    topMessages(topFlag) {
      if (topFlag == false) {
        this.insertData.topMessage = "";
      } else {
        this.getWarnType();
      }
    },
    /**
     * 当前工厂的通道信息
     */
    getWarehouse() {
      this.$http
        .request({
          url: "/api/warehouse/getWarehouse",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.warehouseList = resp.data.list || [];
          }
        })
        .catch((error) => {});
    },
    changeWhCode() {
      if (this.insertData.pmType == "ORDER") {
        this.getOrderProductList(); //查询最近的工单
      }

      this.warehouseData = this.warehouseList.find(item => item.whCode == this.insertData.whCode)
    },
    //物料列表
    getMaterial() {
      this.$http
        .request({
          url: "/api/material/getMaterialAll",
          method: "GET",
          params: {
            // fcCode: this.insertData.fcCode || null,
            mtCode: this.insertData.matCode || null,
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.materialList = res.data.list;
          } else {
            this.$message.error("错误");
          }
        });
    },
    /* 远程搜索物料编号 */
    remoteMethod(query) {
      this.loading = true;
      if (query != "") {
        this.insertData.matCode = query;
        this.getMaterial();
      } else {
        this.insertData.matCode = "";
        this.getMaterial();
      }
      setTimeout(() => {
        this.loading = false;
        if (this.materialList != undefined) {
          this.materialList = this.materialList.filter((item) => {
            return item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }
      }, 200);
    },
    /**
     * 新增叫料
     */
    insertdialogShow() {
      this.insertData.fcCode = localStorage.getItem("fcCode") || "";
      this.insertData.whCode = localStorage.getItem("whCode") || "";
      this.insertData.requireTime = moment().add("hour", 2).format("YYYY-MM-DD HH:mm:ss"); //需求时间
      this.insertData.pmType = "MATERIAL"; //工单/BOM/物料
      this.dialogShow = true;
      this.factoryData = this.factoryList.find(item => item.fcCode == this.insertData.fcCode)
      this.warehouseData = this.warehouseList.find(item => item.whCode == this.insertData.whCode)

      this.changePmType();
      this.getWarehouse();
    },
    /**
     * 判断是否紧急
     */
    topFunction() {
      let dateBegin = new Date();
      let dateEnd = new Date(this.insertData.requireTime);
      let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差
      let minutes = Math.floor(dateDiff / (60 * 1000)); //计算相差分钟

      if (this.factoryData.urgentTime >= minutes) {
        this.insertData.topFlag = true;
        this.getWarnType();
      } else {
        this.insertData.topFlag = false;
        this.insertData.topMessage = "";
      }
    },

    insertdialogClose() {
      this.dialogShow = false;
      this.insertData = {
        fcCode: localStorage.getItem("fcCode") || "",
        whCode: localStorage.getItem("whCode") || "",
        requireTime: "", //需求时间
        topFlag: false, //是否紧急
        topMessage: "",
        pmType: "ORDER", //叫料方式
        opCode: "",
        prodCode: "", //成品编号
        matCode: "",
        jiaoliaoQuan: "",
        jihuaquan: "",
        matSpecsFlag: true, //是否区分分差
        requireOrder: "", //需求订单
      };
      this.insertDataList = {
        orderList: [],
        resultList: [], //原因
        warehouseAreaList: [],
        bomList: [],
        matList: [],
      }
    },

    /**
     * 叫料方式
     */
    changePmType() {
      if (this.insertData.pmType == "ORDER") {
        this.getOrderProductList();
      } else if (this.insertData.pmType == "BOM") {
        this.getProdList();
      } else if (this.insertData.pmType == "MATERIAL") {
        this.getMaterial();
      }
      this.insertData.opCode = "";
      this.insertData.prodCode = "";
      this.insertData.matCode = "";
      this.insertData.jiaoliaoQuan = 1;
      this.insertDataList.matList = [];
    },
    getBomList() {
      if (this.insertData.pmType == "ORDER" && this.insertData.opCode == "") {
        this.$message({
          type: "warning",
          message: "请选择工单！",
        });
        return;
      }
      if (this.insertData.pmType == "BOM" && (this.insertData.prodCode == "" || this.insertData.whCode == "" || this.insertData.jiaoliaoQuan == "")) {
        this.$message({
          type: "warning",
          message: "BOM、通道及数量都不能为空！",
        });
        return;
      }
      if (this.insertData.requireTime == "" || this.insertData.requireTime == null) {
        this.$message({
          type: "warning",
          message: "请选择需求时间！",
        });
        return;
      }

      if (this.insertData.pmType != "MATERIAL") {
        this.insertDataList.matList = [];
      }

      //如果工单存在叫料数量则按BOM进行处理
      var number = 0;
      if (this.insertData.jiaoliaoQuan > 0) {
        number = this.insertData.jiaoliaoQuan;
      }
			let whCodes = this.insertData.whCode;
			if (this.insertData.fcCode == 'SXC') {
				whCodes = whCodes + ",54";
			}

      this.$http
        .request({
          url: "/api/stockProduceMat/getOrderProductBomListWarehouse",
          method: "GET",
          params: {
            fcCode: this.insertData.fcCode || null, //	当前登录的工厂
            opCode: this.insertData.opCode || null,
            prodCode: this.insertData.prodCode || null,
            whCode: whCodes || null,
            matCode: this.insertData.matCode || null,
            number: number,
            matSpecsFlag: this.insertData.matSpecsFlag || false,
            requireOrder: this.insertData.requireOrder || null,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            let dataMat = res.data || null;

            for (let i in dataMat) {
              dataMat[i].index = this.insertDataList.matList.length;

              if (this.insertData.pmType == "BOM" || this.insertData.pmType == "MATERIAL") {
                // dataMat[i].matRealQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                dataMat[i].matRealQuan = 0;
                if (dataMat[i].matRealQuan < 0) {
                  dataMat[i].matRealQuan = 0;
                }

                dataMat[i].matQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                if (dataMat[i].matQuan < 0) {
                  dataMat[i].matQuan = 0;
                }
              } else if (this.insertData.pmType == "ORDER") {
                if (this.insertData.jiaoliaoQuan != this.insertData.jihuaquan) {
                  // dataMat[i].matRealQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                  dataMat[i].matRealQuan = 0;
                  if (dataMat[i].matRealQuan < 0) {
                    dataMat[i].matRealQuan = 0;
                  }
                } else {
                  // dataMat[i].matRealQuan = dataMat[i].matCountQuan - dataMat[i].matCallQuan;
                  dataMat[i].matRealQuan = 0;
                  if (dataMat[i].matRealQuan < 0) {
                    dataMat[i].matRealQuan = 0;
                  }
                }

                dataMat[i].matQuan = dataMat[i].matCountQuan - dataMat[i].matCallQuan;
                if (dataMat[i].matQuan < 0) {
                  dataMat[i].matQuan = 0;
                }
              }

              dataMat[i].requireTime = this.insertData.requireTime;
              dataMat[i].topFlag = this.insertData.topFlag;
              dataMat[i].topMessage = this.insertData.topMessage;
              dataMat[i].requireOrder = this.insertData.requireOrder || "";

              dataMat[i].matFcCode = localStorage.getItem("fcCode") || "";
              this.insertDataList.matList.push(dataMat[i]);
            }
          } else {
            this.$message.error(res.message);
          }
        });
    },
    delList(id) {
      var index = this.insertDataList.matList.findIndex((item) => {
        if (item.index == id) {
          return true;
        }
      });
      this.insertDataList.matList.splice(index, 1);
    },

    getPrintList() {
      if (this.checkListMain.length == 0) {
        this.printShow = true;
      } else {
        var code = 0;
        var whCode = this.checkListMain[0].whCode;
        this.checkListMain.forEach((item) => {
          // if (item.whCode != whCode) {
          //     code += 1;
          // }
          if (this.spIdList.indexOf(item.spId) < 0) {
            this.spIdList.push(item.spId);
            //this.sumNumber += item.matQuan;
          }
        });

        // if (code != 0) {
        //     this.$message({
        //         message: "请勾选同一通道下的拣货单！",
        //         type: "warning",
        //     });
        //     return
        // }

        var spId = this.spIdList.join(",");

        if (this.checkListMain[0].operaType == "10") {
          this.operaType = "叫料";
        } else if (this.checkListMain[0].operaType == "20") {
          this.operaType = "部门领用";
        } else if (this.checkListMain[0].operaType == "30") {
          this.operaType = "采购退货";
        } else if (this.checkListMain[0].operaType == "50") {
          this.operaType = "冻结";
        } else if (this.checkListMain[0].operaType == "60") {
          this.operaType = "外协";
        }
        this.whCodes = whCode;
        //this.printShow = true;
        this.$http
          .request({
            url: "/api/order/getPickNotCloseList",
            method: "GET",
            params: {
              pageNum: 0,
              pageSize: 0,
              spId: spId || null,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              if (resp.data.list != null) {
                this.printsList = resp.data.list;
                var matCode = resp.data.list[0].matCode || "";
                this.printList = [];
                this.summarySumNumber = 0;
                this.sumNumber = 0;
                this.printsList.forEach((item, index) => {
                  if (matCode == item.matCode) {
                    this.sumNumber += item.matQuan;
                    this.printList.push(item);
                  } else {
                    this.printList.push({ matQuan: this.sumNumber });
                    this.printList.push(item);
                    matCode = item.matCode;
                    this.summarySumNumber += this.sumNumber;
                    this.sumNumber = item.matQuan;
                  }
                });
                this.printList.push({ matQuan: this.sumNumber });
                this.summarySumNumber += this.sumNumber;
                this.boxNumber = resp.data.total;
                this.persons = resp.data.list[0].userName || "";
                this.printShow = true;
              } else {
                this.$message({
                  message: "未找到拣货详情打印记录！",
                  type: "warning",
                });
              }
            }
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
      }
    },

    /**
     * 确认叫料
     */
    insertStockProductMat() {
      if (this.insertDataList.matList.length == 0) {
        this.$message({
          type: "warning",
          message: "没有物料",
        });
        return;
      }

      //判断当前数量是否超过物料需求数量
      var matCode = "";

      for (var index in this.insertDataList.matList) {
        var row = this.insertDataList.matList[index];
        if (row.matCountQuan - row.matCallQuan < row.matRealQuan) {
          if (matCode == "") {
            matCode = row.matCode;
          } else {
            matCode += "," + row.matCode;
          }
        }
        if (row.matRealQuan == 0) {
          this.$message({
            type: "warning",
            message: "实际需求数量不能为0!",
          });
          return;
        }
        if (row.matRealQuan > row.whQuan) {
          this.$message({
            type: "warning",
            message: "实际需求数量不能超过当前库存!",
          });
          return;
        }
      }

      // if (this.insertDataList.matList.length > 10) {
      //   this.$message({
      //     type: "warning",
      //     message: "叫料明细不能超过10条",
      //   });
      //   return;
      // }

      var message = "是否确认叫料?";
      if (matCode != "") {
        message = "当前叫料数量超过工单数量" + matCode;
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.insertStockProductMats = true;
          var matList = [];
          this.insertDataList.matList.forEach((element) => {
            element.loginWhCode = localStorage.getItem("whCode") || ''
            if (element.matSpecsAndWhQuan != undefined) {
              element.whQuan = element.specsList[element.matSpecsAndWhQuan].whQuan;
              element.matSpecs = element.specsList[element.matSpecsAndWhQuan].matSpecs;
            }

            if (element.matRealQuan > 0) {
              matList.push(element);
            }
          });

          this.$http
            .request({
              url: "/api/stockProduceMat/insertStockProductMatWarehouse/" + this.person + "/" + this.personNumber + "/" + this.insertData.pmType,
              method: "POST",
              showLoading: true,
              data: matList,
              params: {
                whCode: this.insertData.whCode,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.logRemarks = "stockProduceMat：叫料成功";
                this.insertdialogClose();
                this.getTableData();
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
                this.logRemarks = "stockProduceMat：叫料失败";
              }
              this.insertStockProductMats = false;
              this.logContent = JSON.stringify(this.insertDataList.matList);
              this.systemLog();
            })
            .catch((error) => {
              this.insertStockProductMats = false;
              this.$message({
                message: "操作失败",
                type: "error",
              });
            });
        })
        .catch(() => {
          this.insertStockProductMats = false;
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /**
     * 禁选
     */
    checkboxMain(row, rowIndex) {
      if (row.status == "CREATE") {
        return true; // 不禁用
      } else {
        return false; // 禁用
      }
    },
    /**
     * 全选
     */
    selectAllMain(val) {
      this.checkListMain = val;
    },

    /**
     * 重置
     */
    resetMain() {
      this.mainSearch = {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        whCode: localStorage.getItem("whCode") || "", //通道编号
        pmCode: "", //	生产叫料编号
        opCode: "", //	生产工单编号
        prodCode: "", //	物料编号
        matCode: "", //	物料编号
        status: "PICK,PICKING", //	状态
        date: [],
      };
    },

    /**
     * 紧急原因
     * */
    getWarnType() {
      this.$http
        .request({
          url: "/api/warnType/getWarnType",
          method: "GET",
          params: {
            fcCode: this.insertData.fcCode || null,
            wtType: "10",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.insertDataList.resultList = resp.data;
          }
        })
        .catch((error) => {});
    },
    //获取数据
    getFactoryAll() {
      this.$http
        .request({
          url: "/api/factory/getFactoryAll",
          method: "GET",
          params: {},
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.factoryList = resp.data.list || [];
          }
        })
        .catch((error) => {
          this.loading++;
        });
    },
    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.mainSearch.fcCode || null, // 工厂编号
        whCode: this.mainSearch.whCode || null,
        pmCode: this.mainSearch.pmCode || null, // 生产叫料编号
        opCode: this.mainSearch.opCode || null, // 生产工单编号
        prodCode: this.mainSearch.prodCode || null, // 物料编号
        matCode: this.mainSearch.matCode || null, // 物料编号
        status: this.mainSearch.status || null, // 状态
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, // 开始时间
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, // 结束时间
        pageNum: 1,
        pageSize: 999999,
      };
      this.$http
        .request({
          url: "/api/stockProduceMat/getStockProductList",
          method: "GET",
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function(c) {
          if (c.status == "CREATE") {
            c["status"] = "创建";
          } else if (c.status == "PICK") {
            c["status"] = "待拣货";
          } else if (c.status == "PICKING") {
            c["status"] = "拣货中";
          } else if (c.status == "PICKCOMPLETE") {
            c["status"] = "拣货完成";
          } else if (c.status == "CHECKOUT") {
            c["status"] = "配送出库";
          } else if (c.status == "COMPLETE") {
            c["status"] = "完成";
          } else if (c.status == "CLOSE") {
            c["status"] = "关闭";
          }

          if (c.topFlag == false) {
            c["topFlag"] = "否";
          } else if (c.topFlag == true) {
            c["topFlag"] = "是";
          }
        });
        const tHeader = ["通道编号", "成品编号", "物料编号", "物料描述", "物料需求数量", "已发数量", "规值", "生产工单", "生产叫料编号", "需求时间", "状态", "是否紧急", "紧急原因", "最小包装量", "操作人", "创建时间", "更新时间"];
        const filterVal = ["whCode", "produceCode", "matCode", "matName", "matRealQuan", "matPickQuan", "matSpecs", "opCode", "pmCode", "requireTime", "status", "topFlag", "topMessage", "minBoxNum", "person", "createTime", "updateTime"];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "生产叫料",
        });
        this.logContent = "导出";
        this.logRemarks = "stock_product：导出生产叫料记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    prints() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请选择打印单！",
          type: "warning",
        });
        return;
      }
      let num = 0;
      this.checkListMain.forEach((item) => {
        if (item.status == "PICKING") {
          num += 1;
        }
      });
      this.printList = this.checkListMain;
      this.printShow = true;
      this.getTime();
    },

    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },
    printObjList() {
      let code = [];
      for (let i in this.printList) {
        code.push(this.printList[i].pmCode);
      }
      let stringCode = code.join(",");
      this.$http
        .request({
          url: "api/stockPrintDocument/insertStockPrintDocument",
          method: "POST",
          showLoading: true,
          params: {
            operaCode: stringCode,
            operaType: "10",
            fcCode: localStorage.getItem("fcCode") || "",
            person: localStorage.getItem("user"),
            personNumber: localStorage.getItem("empNumber"),
          },
        })
        .then((resp) => {})
        .catch((error) => {});
    },

    /**
     * 关闭-叫料单
     */
    closeMatByPick(rowItem) {
      this.$http
        .request({
          url: "/api/stockProduceMat/closeMatByPick",
          method: "",
          params: {
            pmId: rowItem.pmId,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            let message = "";
            if (resp.data) {
              message = "当前叫料单拣货中，不能关闭?";
              this.$message({
                message: message,
                type: "error",
              });
              return;
            } else {
              message = "是否关闭当前叫料单：" + rowItem.pmCode + "-" + rowItem.pmId + "?";
            }
            this.closeProductionCall(message, rowItem);
          } else {
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },
    closeProductionCall(message, rowItem) {
      this.$confirm(message, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/stockProduceMat/closeStockProductMat",
              method: "POST",
              showLoading: true,
              params: {
                pmId: rowItem.pmId,
                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),
                type: "ordinary", //普通关闭
                //type: 'force', //强制关闭
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.logRemarks = "stockProduceMat：叫料单关闭成功";
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
                this.logRemarks = "stockProduceMat：叫料单关闭失败";
              }
              this.logContent = JSON.stringify("pmCode：" + rowItem.pmCode);
              this.systemLog();
              this.getTableData();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败",
                type: "error",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    getWhDetails(row) {
      this.whDetailShow = true;
      this.whDetailList = [];

      this.$http
        .request({
          url: "/api/stockProduceMat/getWhCountDetailsWarehouse",
          method: "",
          params: {
            fcCode: row.fcCode || null,
            // fcCode: this.insertData.fcCode || null,
            whCode: row.whCode || null,
            matCode: row.matCode || null,
            matSpecs: row.matSpecs || null,
            requireOrder: this.insertData.requireOrder || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.whDetailList = resp.data || null;
          } else {
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "生产叫料",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss">
.ProductionCall {
  .div div {
    width: 170px;
    height: 50px;
    /* border: 1px solid black; */
    margin-left: 10px;
    margin-top: 10px;
    float: left;
    font-weight: 550;
    font-size: 18px;
    color: black;
  }

  .h-table .el-table {
    .el-table__header {
      table-layout: initial;
      // width: 100% !important;
    }

    //蓝色表头
    thead tr {
      height: 45px;
      color: rgb(0, 0, 0, 0.7);
      background-color: #ddd;
      font-size: 16px;

      th {
        max-width: 60px !important;
        background-color: inherit !important;
        text-align: center;

        div {
          width: 60px;
          display: inline-block;
          // width: 2rem;
        }
      }
    }

    tbody tr {
      td {
        text-align: center;
      }
    }
  }
}

.div div {
  width: 150px;
  height: 30px;
  // border: 1px solid black;
  float: left;
  font-size: 15px;
  font-weight: bold;
  color: black;
  text-align: left;
}

.table td {
  color: black;
  text-align: center;
}

.tr td {
  height: 40px;
}

.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}

.btnCircle {
  padding: 5px !important;
  height: auto !important;
  font-size: 12px !important;
}
</style>
